import { Dropdown, DropdownItem } from 'flowbite-react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router';

import { LOCALES, NAVIGATION } from '@src/constants';
import { createLinkWithNewSubdomain } from '@src/helpers/host.helpers';
import { getCurrentLocaleOption } from '@src/helpers/locales.helpers';

export const HeaderLanguageDropdown = () => {
  const { i18n } = useTranslation();

  const { pathname } = useLocation();
  const isLoginPage = pathname == NAVIGATION.LOGIN;

  const { region = '' } = getCurrentLocaleOption(i18n.language);

  return (
    isLoginPage && (
      <div className="absolute right-2">
        <Dropdown label={region.toUpperCase()} inline>
          {Object.values(LOCALES).map(({ id, code, region = '' }) => (
            <DropdownItem
              key={'language' + id + code}
              className="uppercase"
              as={Link}
              to={createLinkWithNewSubdomain(region) + NAVIGATION.LOGIN}
            >
              {region}
            </DropdownItem>
          ))}
        </Dropdown>
      </div>
    )
  );
};
